module.exports = __webpack_public_path__ + "static/media/front_corner_flipped.6274ae4e.png";